export default __webpack_public_path__ + "static/media/smart_switch.e38a42a0.svg";